import React, { useState } from 'react'
import AboutPage from './AboutPage/AboutPage'
import Footer from './components/common/Footer/Footer'
import NavBar from './components/common/Navbar/Navbar'
import HomePage from './HomePage/HomePage'
import PlaybackAudio from './PlaybackAudio'
import logo from './resources/logo.png'
const App = () => {
  const [selectedTab, setSelectedTab] = useState('home')
  const renderPage = () => {
    if (selectedTab.includes('about')) {
      return <AboutPage />
    } else if (selectedTab.includes('record')) {
      return <PlaybackAudio />
    } else {
      return <HomePage />
    }
  }

  return (
    <>
      <NavBar onChangeTab={setSelectedTab} />
      {renderPage()}
    </>
  )
}
export default App
